import React from 'react';
import './trustUs.css';
import {Image, Container, Col, Row} from "react-bootstrap";
import TrustRow from "../accesories/RowElements/TrustRow";


function TrustUs({content={}}) {
    return (
        <Container className={'trust-us-container'}>
            <Row className="trust-us-up-row">
                <h3>آنچه داپا را <span>متمایز</span> می‌کند</h3>
                <div className="horizontal-line"/>
            </Row>
            {Array.isArray(content.items) && content.items.length > 0 &&
                <Row className={'trust-us-down-row'}>
                    <Col className={'trust-us-right-col'} sm={12} md={12} lg={12} xl={6}>
                        <Row>
                            {
                                content.items.map((item, index) =>{
                                    console.log(item)
                                    return(

                                        <TrustRow key={index} title={item.title}
                                                  desc={item.description}
                                                  icon={<i className={`icon-part fa-light fa-${item.icon}`}></i>}/>
                                    )
                                } )
                            }
                        </Row>


                    </Col>
                    <Col className={'trust-us-left-col'} sm={12} lg={12} xl={6}>
                        <div className="image-wrapper">
                            <Image src={content.image}/>
                        </div>
                    </Col>
                </Row>

            }
        </Container>
    );
}

export default TrustUs;